export default __webpack_public_path__ + "97c2b7dae97eeda809df5002f3c46bfc.pdf";